import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBillingIntervalTypesQuery from '@/graphql/contracts/getBillingIntervalTypes.query.gql';
import GetBillingTypesQuery from '@/graphql/contracts/getBillingTypes.query.gql';
import GetUsageHeaderStatusesQuery from '@/graphql/contracts/getUsageHeaderStatuses.query.gql';
import GetVarBillingUsageDetailsStatusesQuery from '@/graphql/contracts/getVarBillingUsageDetailsStatuses.query.gql';
import {
  GetBillingIntervalTypes,
  GetBillingIntervalTypesVariables
} from '@/graphql/contracts/_generated_/getBillingIntervalTypes.query';
import { GetUsageHeaderStatuses, GetUsageHeaderStatusesVariables } from
  '@/graphql/contracts/_generated_/getUsageHeaderStatuses.query';
import { GetVarBillingUsageDetailsStatuses, GetVarBillingUsageDetailsStatusesVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageDetailsStatuses.query';
import { GetBillingTypes, GetBillingTypesVariables } from '@/graphql/contracts/_generated_/getBillingTypes.query';

export class PreloadData {
  static billingIntervals() {
    const result = apolloClientContracts.cache.readQuery<GetBillingIntervalTypes, GetBillingIntervalTypesVariables>({
      query: GetBillingIntervalTypesQuery,
      variables: {
        includeNonShowable: true,
      }
    });

    if (result?.billingIntervalTypes?.length) {
      return [...result?.billingIntervalTypes];
    }

    return [];
  }

  static billingTypes() {
    const result = apolloClientContracts.cache.readQuery<GetBillingTypes, GetBillingTypesVariables>({
      query: GetBillingTypesQuery,
    });

    if (result?.billingTypes?.length) {
      return result?.billingTypes;
    }

    return [];
  }

  static usageHeaderStatuses() {
    const result = apolloClientContracts.cache.readQuery<GetUsageHeaderStatuses, GetUsageHeaderStatusesVariables>({
      query: GetUsageHeaderStatusesQuery,
    });

    if (result?.usageHeaderStatuses?.length) {
      return result?.usageHeaderStatuses;
    }

    return [];
  }

  static varBillingUsageDetailsStatuses() {
    const result = apolloClientContracts.cache.readQuery<
    GetVarBillingUsageDetailsStatuses, GetVarBillingUsageDetailsStatusesVariables>({
      query: GetVarBillingUsageDetailsStatusesQuery,
    });

    if (result?.varBillingUsageDetailStatuses?.length) {
      return result?.varBillingUsageDetailStatuses;
    }

    return [];
  }
}